// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e138bd62","455":"008a68c5","977":"d816d06d"}[chunkId] + ".chunk.js";
};